<template>
  <main id="main">  
    <workspace v-if="isWorkspace"></workspace>
    <dashboard v-if="isDashboard"></dashboard>
  </main>
</template>

<script>
import Dashboard from './dashboard/Dashboard.vue'
import Workspace from './workspace/Workspace.vue'

export default {
  components: {
    'workspace': Workspace,
    'dashboard': Dashboard
  },
  computed: {
    view() {
      return this.$store.getters.view
    },
    isWorkspace() {
      return this.$store.getters.view === 'workspace'
    },
    isDashboard() {
      return this.$store.getters.view === 'dashboard'
    }
  }
}
</script>
